<div fxFlex="0 0 100%" fxLayout="row wrap" class="assignments-select">
    <app-sticky-header
        class="sticky-header"
        [title]="data.title"
        context="Notes"
        i18n-context
        contextIcon="document_scanner"
        [showSubmit]="false"
        (onCancel)="bottomSheetRef.dismiss(data)"
    ></app-sticky-header>
    <div class="notes-listing-sheet-content">
        <app-shared-hr-notes
            *ngIf="data.isUser"
            #notesList
            (onAddNote)="bottomSheetRef.dismiss(data)"
            (onEditNote)="bottomSheetRef.dismiss(data)"
            (onDeleteNote)="bottomSheetRef.dismiss(data)"
            (onCommentNote)="bottomSheetRef.dismiss(data)"
            [user]="data.item"
            activeSorting="created_at"
            activeSortingDir="desc"
            class="accounts-hr-notes-parent"
            [columns]="['created_at', 'author', 'notes', 'tags', 'tools']"
            [pageSize]="25"
        ></app-shared-hr-notes>

        <app-shared-hr-notes
            *ngIf="!data.isUser"
            #notesList
            [columns]="['created_at', 'author', 'contact_type', 'notes', 'tags', 'tools']"
            [customerId]="data.item.id"
            [hasContactType]="true"
            activeSorting="created_at"
            activeSortingDir="desc"
            [hasNoteContext]="true"
            [noteVisibilityOptions]="noteVisibilityOptions"
            (onAddNote)="bottomSheetRef.dismiss(data)"
            (onEditNote)="bottomSheetRef.dismiss(data)"
            (onDeleteNote)="bottomSheetRef.dismiss(data)"
            (onCommentNote)="bottomSheetRef.dismiss(data)"
            class="customer-hr-notes-parent"
            [pageSize]="5"
        ></app-shared-hr-notes>
    </div>
</div>
